<template>
    <section class="userSteps">
        <div class="userSteps_header d-flex align-items-center align-items-center justify-content-between">
            <a href="javascript:void(0)" class="logo d-block"><img src="assets/images/logo.svg" alt="Logo"
                    title="ZuluTrade Web Application" /></a>
            <div class="rightBTN d-flex align-items-center justify-content-end">
                <a href="javascript:void(0)" class="d-flex align-items-center me-5 medium linkBtn"><img
                        src="assets/images/mobileApp.svg" alt="Icon" title="ZuluTrade App Download" class="me-2" />
                    Download
                    app</a>
                <a href="javascript:void(0)" class="medium linkBtn"> English</a>
            </div>
        </div>
        <div class="d-flex justify-content-end padSpace">
            <button type="button" class="close_btn">
                <vue-feather size="26" type="x"></vue-feather>
            </button>
        </div>
        <div class="publicProfile row align-items-center">
            <div class="col-12 d-flex align-items-center justify-content-between mb-4">
                <router-link class="d-flex align-items-center backBtn medium" to="/crypto-exhange-account1">
                    <vue-feather class="me-2" type="arrow-left" size="15"></vue-feather> Back
                </router-link>
                <div class="counterStep text-end">
                    <p>2 out of 3</p>
                </div>
            </div>
            <div class="col-12">
                <div class="mainTitle mb-5">
                    <h3 class="mb-3 clash">Connect your <span class="bgTitle">Exchange account</span></h3>
                    <p>You don’t have a Broker account? <a class="underline" href="javascript:void(0)">Explore Exchange
                            list</a></p>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <form class="personalDetails">
                    <div class="brokerSearchList form-group position-relative form-group"
                        :class="brokers ? 'selected' : ''">
                        <input @click="brokers = !brokers" type="text" class="form-control"
                            placeholder="Crypto exchange account">
                        <vue-feather class="absoluteDown" size="20" type="chevron-down"></vue-feather>
                        <label class="afterSelect">Crypto exchange account</label>
                        <ul class="dropdown_menu_animated scrollable" :class="brokers ? 'show' : ''">
                            <li>
                                <a href="javascript:void(0)" class="d-flex align-items-center justify-content-between">
                                    <span class="d-flex align-items-center f-15 dark"><img class="me-1"
                                            src="assets/images/capitalWallet.png" alt="Logo" title="AAAFX" /> Capital
                                        Wallet </span>
                                    <span class="semibold f-13 d-flex align-items-center">Free Copy Trading <span
                                            class="infoIcon position-relative">
                                            <vue-feather class="opcity ms-1" type="info" size="20"></vue-feather>
                                        </span>
                                    </span>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <float-label class="form-group">
                        <input type="text" class="form-control" placeholder="API Key" />
                    </float-label>
                    <float-label class="form-group mb-1">
                        <div class="position-relative iconInput">
                            <input type="password" class="form-control" placeholder="API Secret" />
                            <vue-feather class="position-absolute eye pointer" type="eye-off" size="23"></vue-feather>
                        </div>
                    </float-label>
                    <div class="form-group mt-3 mb-4">
                        <label class="customCheckBox">I consent to the broker's <a data-bs-toggle="modal"
                                data-bs-target="#exampleModal" class="semibold underline"
                                href="javascript:void(0)">Letter of Direction</a>
                            <input type="checkbox" />
                            <span class="checkmark"></span>
                        </label>
                    </div>
                    <div class="buttonElement mb-3">
                        <router-link to="/crypto-exhange-account3" class="grd_btn full_size"> Connect account</router-link>
                    </div>
                </form>
            </div>
            <div class="col-12 col-md-6">
                <div class="accordion accordion-flush ps-5" id="accordionFlushExample">
                    <h4 class="semibold">Frequently asked questions</h4>
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="flush-headingOne">
                            <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                data-bs-target="#flush-collapseOne" aria-expanded="false"
                                aria-controls="flush-collapseOne">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit
                            </button>
                        </h2>
                        <div id="flush-collapseOne" class="accordion-collapse collapse show"
                            aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                            <div class="accordion-body">Cras in rhoncus leo, a facilisis eros. Nullam lobortis, orci non
                                commodo laoreet, neque elit blandit ligula, sed fermentum risus ante quis ligula.
                                Integer malesuada posuere hendrerit. Vestibulum rhoncus rutrum arcu sed interdum.</div>
                        </div>
                    </div>
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="flush-headingTwo">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target="#flush-collapseTwo" aria-expanded="false"
                                aria-controls="flush-collapseTwo">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit
                            </button>
                        </h2>
                        <div id="flush-collapseTwo" class="accordion-collapse collapse"
                            aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
                            <div class="accordion-body">Cras in rhoncus leo, a facilisis eros. Nullam lobortis, orci non
                                commodo laoreet, neque elit blandit ligula, sed fermentum risus ante quis ligula.
                                Integer malesuada posuere hendrerit. Vestibulum rhoncus rutrum arcu sed interdum.</div>
                        </div>
                    </div>
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="flush-headingThree">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target="#flush-collapseThree" aria-expanded="false"
                                aria-controls="flush-collapseThree">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit
                            </button>
                        </h2>
                        <div id="flush-collapseThree" class="accordion-collapse collapse"
                            aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample">
                            <div class="accordion-body">Cras in rhoncus leo, a facilisis eros. Nullam lobortis, orci non
                                commodo laoreet, neque elit blandit ligula, sed fermentum risus ante quis ligula.
                                Integer malesuada posuere hendrerit. Vestibulum rhoncus rutrum arcu sed interdum.</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <div class="modal letterDir fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header border-0">
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <h3 class="mb-4">Letter of Direction for the use of the Zulutrade Platform</h3>
                    <p>By utilizing this website, you agree to be bound by these terms and conditions. This is a legal
                        agreement ("Agreement") between you and Zulu Trade Ltd, or any of its affiliated entities
                        ("ZuluTrade") for use of the website, data, ZuluTrade electronic trading platform, and products
                        and services which you selected or initiated, which may include the ZuluTrade trading platform
                        and third party signal providers ("Products and Services").</p>
                    <h6>1. Scope – General Information</h6>
                    <p><strong class="d-block">1.1. Scope of agreement</strong>
                        This is a legal agreement (hereinafter the "Agreement") between you and Zulu Trade Ltd
                        ("ZuluTrade") for use of the website, data, ZuluTrade electronic trading platform, and products
                        and services which you selected or initiated, which may include the ZuluTrade trading platform
                        and third party signal providers ("Products and Services").</p>
                    <p><strong class="d-block">1.2. ZuluTrade and the Zulutrade Platform</strong>1.2.1. ZuluTrade is a
                        technology provider that provides to a number of FX and CFD Brokers and to their respective
                        clients the possibility to integrate in their business relationship the functionality of the
                        Zulutrade Trading Platform (hereinafter the “Zulutrade Platform” or the “Platform”).</p>
                    <p>1.2.2. The ZuluTrade Platform is an automated trading system, allowing a Broker’s client to
                        reproduce in his/her trading account held with the Broker (the “Trading Account”), in an
                        automated way and subject to the application of various parameters and limitations, trading
                        signals generated by third parties (the “Signal Providers” or “Traders”), as further set out in
                        this agreement and explained on the Platform’s website.</p>
                    <p>1.2.3. Any reference to your “Account” in the Platform and generally in relation to ZuluTrade,
                        for the purposes of this Agreement, shall mean the personalized operation of the Platform
                        concerning you, your relations with ZuluTrade and the transactions made by you through the use
                        of the Platform’s functionality, as well as the capture and recording of such operation in the
                        records and servers of ZuluTrade. Except for the purpose of receiving the applicable fees,
                        ZuluTrade shall not receive or keep money or other assets belonging to you and, therefore, the
                        meaning of the term “Account”, as defined above, does not refer to the holding of any of your
                        assets.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FloatLabel from 'vue-float-label/components/FloatLabel'
export default {
    data() {
        return {
            selectButton: false,
            selectNumber: false,
            brokers: false,
            selecServer: false,
        }
    },
    computed: {
        isActive() {
            return false
        }
    },
    components: {
        FloatLabel
    },
}
</script>